module.exports = __webpack_public_path__ + "static/media/login_logo.7c32e60d.png";